import { getVehiculos, createVehiculo, updateVehiculo, deleteVehiculo } from '../models/vehiculoModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase.js';
import { toasts } from "svelte-toasts";

export async function fetchVehiculos(page, perPage) {
  try {
    const response = await getVehiculos(page, perPage);
    return {
      vehiculo: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching vehículos:", error);
    Swal.fire('Error', 'No se pudieron cargar los vehículos', 'error');
    return null;
  }
}

export async function saveVehiculo(vehiculo, currentVehiculoId) {
  try {
    if (currentVehiculoId) {
      await updateVehiculo(currentVehiculoId, vehiculo);
      toasts.add({
        title: 'Éxito',
        description: 'Vehículo actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createVehiculo(vehiculo);
      toasts.add({
        title: 'Éxito',
        description: 'Vehículo creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving vehículo:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el vehículo',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeVehiculo(id) {
  try {
    await deleteVehiculo(id);
    toasts.add({
      title: 'Éxito',
      description: 'Vehículo eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting vehículo:", error);
    Swal.fire('Error', 'No se pudo eliminar el vehículo', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'vehiculo'
export function subscribeToVehiculos(searchQuery, handleSearch) {
  pb.collection('vehiculo').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromVehiculos() {
  pb.collection('vehiculo').unsubscribe('*');
}

export async function searchVehiculos(query, page = 1, perPage = 10) {
  const response = await pb.collection('vehiculo').getList(page, perPage, {
    filter: `placa ~ "${query}" || marca ~ "${query}" || modelo ~ "${query}"`,
  });
  return {
    vehiculo: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}